import axios from "axios";
import config from "../../../config";

const getReferentielData = async (reference) => {
  try {
    const response = await axios({
      method: "post",
      url: `${config.referentielBaseURL}api/referentiel/getAll`,
      headers: {
        Authorization: `${config.referentielToken}`,
      },
      data: {
        cleReferentiel: reference,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReferentielPaginationData = async (
  reference,
  body,
  pageNumber,
  pageSize
) => {
  try {
    const response = await axios({
      method: "post",
      url: `${config.referentielBaseURL}api/referentiel/getPage`,
      headers: {
        Authorization: `${config.referentielToken}`,
      },
      data: {
        cleReferentiel: reference,
        ...body,
        langue: "fr",
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReferentielDataFromServer = async (
  urlStatic = false,
  api,
  body,
  method = "post",
  token = localStorage.getItem("token")
) => {
  try {
    const response = await axios({
      method: method,
      url: urlStatic ? api : `${config.baseURL}${api}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        ...body,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    if (error.status === 401 || error.response.status === 403)
      return {
        error: true,
        status: 403,
        response: "UNAUTHORIZED",
        session_id: "3d656ff7-25e6-47b3-af9f-0b5b25b97256",
        user_query: "hello",
      };
    else {
      return {
        error: true,
        response:
          "Une erreur s'est produite. Veuillez réessayer ultérieurement...",
        session_id: "3d656ff7-25e6-47b3-af9f-0b5b25b97256",
        user_query: "hello",
      };
    }
  }
};

export const getReferentielDataFromGoogle = async (
  api,
  body,
  method = "post"
) => {
  try {
    const response = await axios({
      method: method,
      url: api,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("provider_token")}`,
      },
      data: {
        ...body,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user info:", error);
  }
};

export default getReferentielData;
